import hash from 'object-hash'

export default function hashObject (params) {
  return hash(typeof params === 'string' ? params : JSON.stringify(params))
}
